<template>
    <v-container class="pa-5" fluid>
        <ConfirmDialog
            :is-open="confirmCreateOrderDialog"
            :data="currentCalculation"
            :action-loading="actionLoading.createOrder"
            @on-confirm="createOrder"
            @on-abort="closeConfirmCreateOrderDialog"
        >
            <template #title>
                Składanie zamówienia z kalkulacji
            </template>
            <template #content>
                Czy na pewno chcesz utworzyć zamówienie?
            </template>
            <template #confirmButton>
                Zatwierdź
            </template>
        </ConfirmDialog>

        <ConfirmDialog
            :is-open="confirmDeleteCalculationDialog"
            :data="currentCalculation"
            :action-loading="actionLoading.deleteCalculation"
            removal
            @on-confirm="deleteCalculation"
            @on-abort="closeConfirmDeleteCalculationDialog"
        >
            <template #title>
                Usuwanie kalkulacji
            </template>
            <template #content>
                Czy na pewno chcesz usunąć kalkulację?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <ConfirmDialog
            :is-open="confirmCopyCalculationDialog"
            :data="currentCalculation"
            :action-loading="actionLoading.copyCalculation"
            @on-confirm="copyCalculation"
            @on-abort="closeConfirmCopyCalculationDialog"
        >
            <template #title>
                Kopiowanie kalkulacji
            </template>
            <template #content>
                Czy na pewno chcesz skopiować kalkulację?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>

        <page-title>Kalkulacje</page-title>

        <v-row align="center">
            <v-col cols="12" sm="4">
                <v-btn
                    color="secondary"
                    medium
                    class="mx-0"
                    data-sentry-label="Nowa kalkulacja"
                    @click="createCalculation"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Nowa kalkulacja
                </v-btn>
            </v-col>
            <v-col cols="12" sm="8" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="filters.status_ids"
                                label="Status"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono statusu"
                                solo
                                clearable
                                hide-details
                                :items="calculationStatusList"
                                @change="changeFilter"
                                @click:clear="clearFilter('status_ids')"
                            />
                        </v-col>
                        <v-col cols="12" sm="5" md="6" lg="6">
                            <v-text-field
                                v-model="filters.search"
                                append-icon="mdi-magnify"
                                label="Szukaj po numerze, nazwie"
                                single-line
                                clearable
                                solo
                                hide-details
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('search')"
                            />
                        </v-col>
                    </v-row>
                    <v-row justify="end" dense>
                        <v-col cols="12" sm="4" md="6">
                            <v-text-field
                                v-model="filters.customerName"
                                append-icon="mdi-magnify"
                                label="Szukaj po kliencie"
                                single-line
                                clearable
                                solo
                                hide-details
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('customerName')"
                            />
                        </v-col>
                        <v-col cols="12" sm="5" md="6" lg="6">
                            <v-autocomplete
                                v-model="filters.createdBy_id"
                                :items="users"
                                :filter="customUsersFilter"
                                :loading="usersSearchLoading"
                                :search-input.sync="usersSearch"
                                label="Tworzący"
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                clearable
                                cache-items
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('createdBy_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearch">
                                                Wpisz treść aby odnaleźć <strong>użytkownika</strong>.
                                            </template>
                                            <template v-else-if="usersSearchLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row justify="end" dense>
                        <v-col cols="12" md="4">
                            <v-menu
                                v-model="creationDateMenuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.createdAt__gte"
                                        label="kalkulacja utworzona od"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        solo
                                        hide-details
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('createdAt__gte')"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.createdAt__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="creationDateMenuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu
                                v-model="creationDateMenuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.createdAt__lte"
                                        label="kalkulacja utworzona do"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        solo
                                        hide-details
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('createdAt__lte')"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.createdAt__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter()"
                                    @input="creationDateMenuTo = false"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="calculations"
                        :loading="calculationsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        :item-class="setSelectedRow"
                        name="calculationsData"
                        @pagination="updatePagination"
                    >
                        <template #item.number="{item}">
                            {{ item.number }}
                        </template>
                        <template #item.name="{item}">
                            {{ item.name }}
                        </template>
                        <template #item.customer="{item}">
                            <template v-if="item.customer">
                                {{ item.customer.name }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>

                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #item.createdBy="{item}">
                            <template v-if="item.createdBy && item.createdBy.firstName && item.createdBy.lastName">
                                {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Generuj ofertę cenową"
                                            v-on="on"
                                            @click="priceOffer(item)"
                                        >
                                            <v-icon color="blue">
                                                mdi-printer
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Generuj ofertę cenową</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <div v-on="on">
                                            <v-btn
                                                icon
                                                :disabled="isCreatingOrderDisabled(item.statusId)"
                                                data-sentry-label="Złóż zamówienie"
                                                @click="showConfirmCreateOrderDialog(item)"
                                            >
                                                <v-icon color="teal">
                                                    mdi-cart-outline
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Złóż zamówienie</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Skopiuj kalkulację"
                                            v-on="on"
                                            @click="showConfirmCopyCalculation(item)"
                                        >
                                            <v-icon color="primary">
                                                mdi-content-copy
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Skopiuj kalkulację</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Otwórz"
                                            v-on="on"
                                            @click="openCalculation(item.id)"
                                        >
                                            <v-icon color="blue">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Otwórz</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            :disabled="item.statusId === 20"
                                            data-sentry-label="Usuń"
                                            v-on="on"
                                            @click="showConfirmDeleteCalculation(item)"
                                        >
                                            <v-icon color="pink">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Usuń</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import ConfirmDialog from '@/components/common/ConfirmDialog'

import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'
import { openPdfFile } from '@/utils/pdfHandler'

import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import tooltipDelay from '@/mixins/tooltip'

import dataTableClassSetter from '@/mixins/dataTableClassSetter'

let searchTimer

export default {
    name: 'Calculations',
    components: {
        PageTitle, ConfirmDialog
    },
    mixins: [
        filters,
        pagination,
        dateFormatter,
        customFilters,
        tooltipDelay,
        dataTableClassSetter
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.clearSelectedListItemId()
            this.$store.dispatch('calculations/clearCalculationsFilters')
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            currentCalculation: {},
            confirmCreateOrderDialog: false,
            confirmDeleteCalculationDialog: false,
            confirmCopyCalculationDialog: false,
            creationDateMenuFrom: false,
            creationDateMenuTo: false,
            actionLoading: {
                deleteCalculation: false,
                createOrder: false,
                priceOffer: false,
                copyCalculation: false
            },
            usersSearch: null,
            users: [],
            usersSearchLoading: false,
            headers: [
                {
                    text: 'Numer kalkulacji',
                    value: 'number',
                    sortable: false
                },
                {
                    text: 'Nazwa kalkulacji',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Klient',
                    value: 'customer',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false
                },
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    sortable: false
                },
                {
                    text: 'Utworzone przez',
                    value: 'createdBy',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'right',
                    width: 100
                }
            ]
        }
    },
    computed: {
        calculations() {
            return this.$store.state.calculations.calculations.calculations
        },
        calculationsLoading() {
            return this.$store.state.calculations.calculations.calculationsLoading
        },
        selectedCalculationId() {
            return this.$store.state.common.selectedListItemId
        },
        savedFilters() {
            return this.$store.state.calculations.calculations.filters
        },
        calculationStatusList() {
            return this.$store.state.calculations.calculations.calculationStatusList
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    watch: {
        usersSearch(value = null) {
            if (value === null) return

            this.usersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsers(value)
                } else {
                    this.usersSearchLoading = false
                    this.users = []
                }
            }, 500)
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.$store.dispatch('calculations/getCalculationsStatuses')
        this.getCalculations()
    },
    methods: {
        searchUsers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika na liście kalkulacji')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(({ data }) => {
                    this.users = data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchLoading = false
                })
        },
        setSelectedRow(item) {
            if (item.id === this.selectedCalculationId) {
                return 'isSelected'
            }
        },
        getCalculations() {
            this.$store.dispatch('calculations/getCalculations', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createCalculation() {
            this.$store.dispatch('calculations/createCalculation', {
                name: `Kalkulacja - ${this.formatDate(new Date())}`,
                calculationProducts: [],
                calculationImpositions: []
            })
                .then(response => {
                    this.$router.push({
                        name: 'calculationsCalculation',
                        params: {
                            id: response.data.id,
                            calculationNumber: response.data.number,
                        }
                    })
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        openCalculation(calculationId) {
            this.saveFiltersCleared()
            this.setSelectedListItemId(calculationId)
            this.$router.push({
                name: 'calculationsCalculation',
                params: {
                    id: calculationId
                }
            })
                .catch(error => errorHandler(error))
        },
        showConfirmCreateOrderDialog(calculation) {
            this.confirmCreateOrderDialog = true
            this.currentCalculation = calculation
        },
        closeConfirmCreateOrderDialog() {
            this.confirmCreateOrderDialog = false
            this.currentCalculation = {}
        },
        createOrder(calculation) {
            this.actionLoading.createOrder = true
            this.$store.dispatch('calculations/updateCalculation', {
                ...calculation,
                sendToProduction: true
            })
                .then(() => {
                    this.$store.dispatch('showNotification', {
                        type: 'success',
                        message: 'Utworzono nowe zamówienie.'
                    })
                    this.getCalculations()
                    this.closeConfirmCreateOrderDialog()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.createOrder = false
                })
        },
        showConfirmDeleteCalculation(calculation) {
            this.confirmDeleteCalculationDialog = true
            this.currentCalculation = calculation
        },
        closeConfirmDeleteCalculationDialog() {
            this.confirmDeleteCalculationDialog = false
            this.currentCalculation = {}
        },
        deleteCalculation(calculation) {
            this.actionLoading.deleteCalculation = true
            this.$store.dispatch('calculations/deleteCalculation', calculation.id)
                .then(() => {
                    this.getCalculations()
                    this.closeConfirmDeleteCalculationDialog()
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.actionLoading.deleteCalculation = false
                })
        },
        isCreatingOrderDisabled(calculationStatus) {
            return calculationStatus !== 15 // zatwierdzone
        },
        priceOffer(data) {
            this.actionLoading.priceOffer = true
            this.$store.dispatch('calculations/printCalculationPriceOffer', {
                calculationId: data.id,
                templateCodes: ['calculation_price_offer']
            })
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.priceOffer = false
                })
        },
        showConfirmCopyCalculation(calculation) {
            this.confirmCopyCalculationDialog = true
            this.currentCalculation = calculation
        },
        closeConfirmCopyCalculationDialog() {
            this.confirmCopyCalculationDialog = false
            this.currentCalculation = {}
        },
        copyCalculation(calculation) {
            this.actionLoading.copyCalculation = true

            const payload = {
                calculationId: calculation.id
            }

            this.$store.dispatch('calculations/copyCalculation', payload)
                .then(() => {
                    this.getCalculations()
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.actionLoading.copyCalculation = false
                    this.closeConfirmCopyCalculationDialog()
                })
        },
        changeFilter() {
            this.$store.dispatch('calculations/setCalculationsFilters', this.filters)
            this.resetPagination()
            this.getCalculations()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getCalculations()
            }
            this.clearPaginationPending()
        },
    }
}
</script>